import { EYEBROW_CLASS, NOTE_CLASS } from "../lib/ui.js";

function MetricBlock({ label, value, note }) {
  return (
    <div className="grid min-w-0 gap-0">
      <div className={NOTE_CLASS}>{label}</div>
      <strong className="text-[14px] leading-[1.04] font-medium">{value}</strong>
      <div className={`mt-1 ${NOTE_CLASS}`}>{note}</div>
    </div>
  );
}

export function InlineMetricGrid({ items }) {
  return (
    <div className="mt-1 grid grid-cols-4 gap-0 border-t border-[color:var(--line-soft)] max-[900px]:grid-cols-1">
      {items.map(([label, value, note], index) => (
        <div
          key={label}
          className={`grid content-start justify-items-start gap-0 pt-2 pr-2.5 ${
            index > 0
              ? "border-l border-[color:var(--line-soft)] pl-3 max-[900px]:border-l-0 max-[900px]:border-t max-[900px]:border-[color:var(--line)] max-[900px]:pl-0 max-[900px]:pt-3"
              : ""
          }`}
        >
          <div className={NOTE_CLASS}>{label}</div>
          <strong className="mt-1 text-[14px] leading-[1.04] font-medium tracking-[-0.04em]">
            {value}
          </strong>
          <div className={`mt-[5px] ${NOTE_CLASS}`}>{note}</div>
        </div>
      ))}
    </div>
  );
}

export default function PageHero({ eyebrow, title, detail = null, metrics = [], controls = null }) {
  return (
    <section className="grid gap-2 pt-3 pb3">
      <div className="grid items-start gap-2 [grid-template-columns:minmax(0,1fr)_auto] max-[900px]:grid-cols-1">
        <div className="grid gap-0">
          <div className={`${EYEBROW_CLASS} min-w-0 truncate`}>{eyebrow}</div>
          <h1 className="mt-[3px] max-w-[840px] text-[18px] leading-[1.16] font-medium tracking-[-0.015em] [text-wrap:balance]">
            {title}
          </h1>
          {detail ? (
            <p className="m-0 mt-[4px] max-w-[840px] text-[12px] leading-[1.45] text-[color:var(--muted)]">{detail}</p>
          ) : null}
        </div>
        {controls ? (
          <div className="grid min-w-[238px] justify-items-end gap-2 max-[900px]:min-w-0 max-[900px]:justify-items-start">
            <div className="flex w-full justify-end max-[900px]:justify-start">{controls}</div>
          </div>
        ) : null}
      </div>
      <div className="grid w-full gap-x-3 gap-y-1 pt-0.5 [grid-template-columns:repeat(auto-fit,minmax(140px,1fr))]">
        {metrics.map((metric) => (
          <MetricBlock
            key={metric.label}
            label={metric.label}
            value={metric.value}
            note={metric.note}
          />
        ))}
      </div>
    </section>
  );
}
